// Owner-confirmed on 2026-09-19, including business not yet entered in the database.
// Presentation only: do not use these totals for admin reports or transaction logic.
export const homepageBusinessMetrics = [
  { label: "形象总数", amount: "3000", value: "3000+" },
  { label: "注册用户", amount: "1 万", value: "1 万+" },
  { label: "授权次数", amount: "1000", value: "1000+" },
] as const;
